export const brandSpecificKey = (brandTypeId: number): "yodlee" | "cobrand" | "channel" | "partner" | "subBrand" => {
    switch (brandTypeId) {
        case 1:
            return "subBrand";
        case 2:
            return "channel";
        case 3:
            return "cobrand";
        case 4:
            return "yodlee";
        case 5:
            return "partner";
        default:
            return "cobrand"
    }

}